export enum ActivePage {
    HOME = 'HOME',
    SCHEDULE = 'SCHEDULE',
    TEMPLATES = 'TEMPLATES'
}
